<template>
  <v-container>
    <v-card class="mx-auto" max-width="800" color="grey darken-2">
      <v-container>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field v-model="name" :counter="30" :rules="nameRules" label="Name" required></v-text-field>

          <v-text-field v-model="email" :rules="emailRules" label="E-mail" required></v-text-field>

          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field v-model="date" label="Datum" readonly v-on="on" ></v-text-field>
            </template>
            <v-date-picker v-model="date" @input="menu2 = false" :first-day-of-week="1"
      locale="de-de"></v-date-picker>
          </v-menu>
          <v-select
            v-model="select"
            :items="time"
            :rules="[v => !!v || 'Bitte geben Sie eine Zeit ein!']"
            label="Zeit"
            required
          ></v-select>
          <v-select
            v-model="select"
            :items="rides"
            :rules="[v => !!v || 'Bitte wählen Sie ein Fahrzeug']"
            label="Fahrzeug"
            required
          ></v-select>

          <v-checkbox
            v-model="checkbox"
            :rules="[v => !!v || 'You must agree to continue!']"
            label="Ich habe"
            required
          ></v-checkbox>

          <v-btn :disabled="!valid" color="success" class="mr-4" @click="validate">Validate</v-btn>

          <v-btn color="error" class="mr-4" @click="reset">Reset Form</v-btn>

          <v-btn color="warning" @click="resetValidation">Reset Validation</v-btn>
        </v-form>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    valid: true,
    name: "",
    nameRules: [
      v => !!v || "Name ist notwendig",
      v => (v && v.length <= 30) || "Nicht mehr als 20 Zeichen erlaubt"
    ],
    email: "",
    emailRules: [
      v => !!v || "E-mail ist notwendig",
      v => /.+@.+\..+/.test(v) || "E-mail muss gültig sein"
    ],
    select: null,
    rides: [
      "1x 2 Sitzer Buggy (2 Personen)",
      "2x 2 Sitzer Buggy (4 Personen)",
      "1x 4 Sitzer Buggy (4 Personen)"
    ],
    time: ["Vormittag", "Nachmittag", "Ganztags"],

    checkbox: false,

    date: new Date().toISOString().substr(0, 10),
  
    menu2: false
  }),

  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    }
  }
};
</script>

